<template>
  <div>
		<winning-numbers-sidebar :open.sync="sidebarOpen" :results="externalLotteriesResults"></winning-numbers-sidebar>
		<v-btn id="external-results-btn" @click="sidebarOpen = !sidebarOpen" style="z-index: 4">
			Winning Numbers
		</v-btn>
    <v-img id="banner" :src="images.Banner"> </v-img>
    <v-row justify="center">
      <v-col cols="auto">
        <v-btn id="see-it-live-btn" @click="scrollToStream">
          See it live
        </v-btn>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col
        lg="4"
        sm="6"
        cols="12"
        v-for="result in results"
        :key="`${result.date}-${result.sortition.id}`"
      >
        <result-display class="result-card" :result="result"></result-display>
      </v-col>
    </v-row>
    <v-responsive :aspect-ratio="16 / 9">
      <iframe
        v-if="channelName && channelName.length > 0"
        id="frame"
        :src="
          `https://player.twitch.tv/?channel=${channelName}&parent=fplay777.net`
        "
        frameborder="0"
        scrolling="no"
        allowfullscreen="true"
      >
      </iframe>
    </v-responsive>
  </div>
</template>

<script>
import ResultDisplay from "./ResultDisplay.vue";
import BaseStream from "../BaseStream.js";
import Banner from 'assets/static/img/logo/fastplay_left.png';

export default {
  name: "Stream",
  components: {
    ResultDisplay
  },
  data() {
    return {
      images: {
        Banner
      }
    };
  },
  extends: BaseStream
};
</script>

<style scoped lang="scss">
@import "css/variables";

.result-card {
  background-color: rgba(0, 70, 228, 0.14);
  padding: 5px;
}

#see-it-live-btn {
  background-color: rgba($blue, 0.8);
  color: white;
}

#external-results-btn {
	background-color: rgba($blue, 0.8);
	color: white;
}

#frame {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

#banner {
  max-width: 50%;
  left: 50%;
  margin-left: -25%;
}
</style>
